import { Button } from '@cian/ui-kit';
import { useDispatch } from 'react-redux';
import React from 'react';

import { setIsNewYearAlertShown } from '../../actions/serviceMessage';
import { NewYearAlertLayout } from './components';
import { SimpleNotification } from '../../components/Notification';
import { NEW_YEAR_MESSAGES, NEW_YEAR_TITLE } from './consts';

export const NewYearContainer: React.FC = () => {
  const dispatch = useDispatch();
  const handleAgreementConfirm = () => {
    dispatch(setIsNewYearAlertShown(true));
  };

  return (
    <NewYearAlertLayout
      title={NEW_YEAR_TITLE}
      content={<SimpleNotification message={NEW_YEAR_MESSAGES} type="warning" testId="new-year-message" />}
      action={
        <Button type="button" onClick={handleAgreementConfirm}>
          Хорошо
        </Button>
      }
    />
  );
};

NewYearContainer.displayName = 'NewYearContainer';
